var _circle, _circle2, _path, _path2, _path3, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time Change") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.59,
    cy: 12.32,
    r: 0.29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.58,
    cy: 2.75,
    r: 0.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.41,8.28v.2a.19.19,0,0,1-.2.19h-3V5.09a.2.2,0,0,1,.2-.2h.2a.2.2,0,0,1,.2.2v3h2.39A.2.2,0,0,1,10.41,8.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16,5.36A5.82,5.82,0,0,1,13,5.36H14a6.81,6.81,0,0,0-12.92,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28,8.56a5.81,5.81,0,0,1-11.43,0h-1a6.8,6.8,0,0,0,13.44,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "11.26 6.78 15 3.22 15 6.78 11.26 6.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 10.83 3.56 7.09 0 7.09 0 10.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeChange);
export default __webpack_public_path__ + "static/media/time_change.cc5d8dbb02f7b7e1af081f35ae348f00.svg";
export { ForwardRef as ReactComponent };